import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.benefitsForPlans],
        config: {
            headerName: getLocalizedString("recognitionPlan"),
            field: 'planString',
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.benefitsForPlans],
        config: {
            headerName: getLocalizedString("planStatus"),
            field: 'planStatus',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.benefitsForPlans],
        config: {
            headerName: getLocalizedString("benefitType"),
            field: 'benefitString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.benefitsForPlans],
        config: {
            headerName: getLocalizedString("activeBenefit"),
            field: 'benefitActive',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.benefitsForPlans],
        config: {
            headerName: getLocalizedString("benefitImage"),
            field: 'benefitImage',
            filter: "agSetColumnFilter",
            cellRenderer: "ImageRenderer",
        }
    },
]